<template>
  <section>
    <vf-notification v-if="errorMessage" class="mb-4" :dismissible="false" type="error" @close="removeErrorNotification">
      {{ errorMessage }}
    </vf-notification>
    <cms-section v-if="eSpots?.['above-dashboard']" :section="eSpots?.['above-dashboard']" />
    <h1 class="mb-6 title-1">
      {{ headerTitle }}
    </h1>
    <div v-if="showEmployeeContactUs && auth.isEmployee">
      <vf-tile
        v-bind="topTiles.employeeContact"
        style="max-width: 18rem"
      >
        <template #title>
          <span style="white-space: pre-line">
            {{ topTiles.employeeContact.title }}
          </span>
        </template>
      </vf-tile>
    </div>
    <div :class="brandClasses.tiles">
      <vf-tile
        v-show="$feature.enableChat"
        v-bind="topTiles.chat"
        data-chat="help:widget"
        :disabled="!isCanada && !$chat.available"
        @click="$chat.open()"
      />
      <vf-tile v-if="hasFaqPage" v-bind="topTiles.ask" />
      <vf-tile v-bind="topTiles.email" @click="toggleForm" />
      <vf-tile v-bind="topTiles.phone" :to="topTiles.phone.link">
        <template #description>
          <span style="white-space: pre-line">
            {{ topTiles.phone.description }}
          </span>
        </template>
      </vf-tile>
    </div>
    <div
      v-show="showForm"
      id="get-in-touch-with-us"
      :style="{ 'scroll-margin-top': `${header.height.full}px` }"
    >
      <form-contact-us
        :class-title="brandClasses.contactFormTitle"
        @display-error="displayErrorNotification($event as Error)"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'change-page-title', title: string): void
}>()

const header = useHeaderStore()

const { data, error } = await useApi().internal.getStaticPage('help/contact-us')
if (!data.value) throw createError({ ...error.value!, fatal: true })
const { headerTitle, topTiles } = data.value
const { $seo } = useNuxtApp()
const auth = useAuthStore()
const route = useRoute()

emit('change-page-title', $seo.helpContactUs.title)

const isCanada = useCountryCode() === 'CA'

const eSpots = (await useCms().getSections.contactUs()).data.value?.content.sectionsMap

const { brandClasses, hasFaqPage, showEmployeeContactUs } = useAppConfig().pages.help

const showForm = ref(false)
const toggleForm = () => {
  showForm.value = !showForm.value
}

if (route.query.form === 'open' && !auth.isEmployee) showForm.value = true

const errorMessage = ref('')
const removeErrorNotification = () => errorMessage.value = ''
const displayErrorNotification = (e) => {
  errorMessage.value = e.message
}
</script>
